import React from "react";
import "./Greeting.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {greeting} from "../../portfolio";

export default function Greeting() {
  if (!greeting.displayGreeting) return null;

  return (
    <div className="hero-section" id="greeting">
      <div className="hero-content">
        <p className="hero-eyebrow">Hello, I am</p>
        <h1 className="hero-name">{greeting.username}</h1>
        <p className="hero-subtitle">
          Engineer &nbsp;·&nbsp; Freelancer &nbsp;·&nbsp; Tech Enthusiast
        </p>
        <div className="hero-social">
          <SocialMedia />
        </div>
        <div className="hero-buttons">
          <Button text="CONTACT ME" href="#contact" />
          {greeting.resumeLink && (
            <Button text="MY RESUME" newTab={true} href={greeting.resumeLink} />
          )}
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <span>Scroll</span>
        <div className="hero-scroll-line" />
      </div>
    </div>
  );
}
